var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Published',{attrs:{"item":_vm.history},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('HistoryView',{attrs:{"id":_vm.id}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }